import {
  Button,
  Icon,
  PageContainer,
} from "@equinor/e-procurement-portal-and-ts-portal-front-end-components";
import { mdiArrowLeft } from "@mdi/js";
import { Alert, Box } from "@mui/material";
import { createFileRoute } from "@tanstack/react-router";
import type { FC } from "react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { z } from "zod";
import { QuotationNegotiationChat } from "../../../../../components/molecules/QuotationNegotiationChat";

const searchSchema = z.object({
  chat_notification_id: z.optional(z.string()).catch(""),
  quotation_id: z.optional(z.coerce.number()).catch(undefined),
  tab: z.optional(z.enum(["chat"])).catch(undefined),
});

const RouteComponent: FC = () => {
  const { negotiationId } = Route.useParams();
  const {
    chat_notification_id: chatNotificationId,
    quotation_id: quotationId,
  } = Route.useSearch();
  const { t } = useTranslation();
  const [scrollToLatestRequest, setScrollToLatestRequest] = useState(0);

  useEffect(() => {
    if (chatNotificationId) {
      setScrollToLatestRequest((request) => request + 1);
    }
  }, [chatNotificationId]);

  return (
    <PageContainer title={t("chat")}>
      <Box>
        <Button
          component="a"
          href={`/vbuyer/negotiations/${negotiationId}`}
          startIcon={<Icon icon={mdiArrowLeft} />}
          sx={{ textTransform: "none" }}
          variant="text"
        >
          {t("common.back")}
        </Button>
      </Box>
      {quotationId === undefined ? (
        <Alert severity="error">
          {t("quotation.chat.negotiationContextMissingMessage")}
        </Alert>
      ) : (
        <QuotationNegotiationChat
          negotiationId={Number(negotiationId)}
          quotationId={quotationId}
          scrollToLatestRequest={scrollToLatestRequest}
        />
      )}
    </PageContainer>
  );
};

export const Route = createFileRoute(
  "/_private/vbuyer/negotiations/$negotiationId/chat",
)({
  component: RouteComponent,
  validateSearch: searchSchema,
});
